import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import Profile from './profile/modules/app';
Profile.init();